import React from 'react'
import { axiosWithKey } from "~/axios"
import userStore from '~/redux/user/store'
import connect from "~/tools/connect";
import {get, groupBy,find, isEmpty } from 'lodash'
import { getLocalizedVal } from '~/tools/localization/helpers'
import Timer from "~/components/Timer"
import {checkVideoContentEntitlement} from "~/tools/checkSeries"
import './styles.scss'

class WaysToWatch extends React.Component {
  constructor(props){
    super(props)
    this.state={
      plansByType:[],
      loading:true,
      emailProcessing:false,
      plans:this.props.plans
    }
    this.dimensions = window.innerWidth <= 600 ? { height: 203, width: 360 } : { height: 480, width: 854 }

  }
  componentDidMount(){
    this.updatePlans()
  }
  updatePlans(){
    if(this.state.plans && this.state.plans.length > 0){
      let groupedPlans= groupBy(this.state.plans, 'monetizationModel')
      this.isFree = Object.keys(groupedPlans) && Object.keys(groupedPlans).includes('FREE')
      this.isTVE = Object.keys(groupedPlans) && Object.keys(groupedPlans).length === 1 && Object.keys(groupedPlans).includes('TVE')
      if(this.isFree){
        const freePlan = find(this.state.plans, function(o){return o.monetizationModel === 'FREE'})
        let {isEmailRequired, isLoginRequired} = freePlan.featureSetting
        this.setState({plansByType:groupedPlans, isEmailRequired:isEmailRequired, isLoginRequired:isLoginRequired, loading:false})
      }else{
        this.setState({plansByType:groupedPlans, isEmailRequired:false, isLoginRequired:false, loading:false})
      }
    }else{
      this.setState({plansByType:[], isEmailRequired:false, isLoginRequired:false, loading:false})
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ plans:nextProps.plans},
      () => {this.updatePlans()});  
  }
  emailForm(){
    return(
      <form className="emailForm" onSubmit={ evt => { this.signUp(evt)} }>
        <label>{getLocalizedVal(window.settings,'genericMessages', 'enterEmailLabel')}</label>
        <input type="email" ref={ i => { this.emailInput = i} } required />
        {this.state.emailRequiredError && <div className="emailError">{ this.state.emailRequiredError}</div>}
        <input className="cta" type="submit" value={this.state.emailProcessing ? getLocalizedVal(window.settings,'genericMessages', 'pleaseWaitMessage') : getLocalizedVal(window.settings,'genericMessages', 'continueCta')} className="cta"/>
      </form>
    )
  }

  async signUp(e) {
    e.preventDefault();
    this.setState({emailProcessing:true})
    let user = {
      email: this.emailInput && this.emailInput.value,
      ignorePassword: true
    }
    let signupParams = {
      site: window.settings.internalName
    }
    await axiosWithKey({
      method: 'POST',
      url: `${window.settings.apiBaseUrl}/identity/signup`,
      params: signupParams,
      data: user,
      headers: {
        'x-api-key': window.settings.baseAPIKey
      }
    }).then( res => {
      localStorage.setItem('emailProcessed', true) 
      this.props.cb && this.props.cb()
    }).catch(err=>{
      const error = get(err, 'response.data')
      if(error && error.code && error.code === "EMAIL_ALREADY_LINKED"){
        localStorage.setItem('emailProcessed', true) 
        this.props.cb && this.props.cb()
      }else{
        this.setState({emailProcessing:false, emailRequiredError:error && error.error})
      }
    })
  }
  render(){
    var ref = this
    let background={}
    if(this.props.videoGist.videoImageUrl){
      background = {
        backgroundImage: `url(${this.props.videoGist.videoImageUrl}?impolicy=resize&w=${this.dimensions.width}&h=${this.dimensions.height})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      }
    }else{
      background={
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      }
    }

    if(this.state.loading)
      return <div className="waysSpinner" style={ background }> <div className="spinner site-color"></div> </div>

    if(this.props.videoGist.scheduleEndDate && this.props.videoGist.scheduleEndDate - Date.now() < 0)
      return <div className="waysSpinner" style={ background }> <div className="contentNotAvailable">{getLocalizedVal(window.settings,'genericMessages', 'videoNotPlayableDialogTitle')}</div></div>

    if(isEmpty(this.state.plansByType) && !this.props.isEpisode)
      return <div className="waysSpinner" style={ background }> <div className="contentNotAvailable">{getLocalizedVal(window.settings,'genericMessages', 'ContentNotAvailableInYourArea')}</div></div>

    if(this.props.videoGist.scheduleStartDate && this.props.videoGist.scheduleStartDate - Date.now() > 0){
      let isVideoEntitled = this.props.content && checkVideoContentEntitlement(this.props.content, this.props.plans)
        return (
          <div className="waysSpinner" style={ background }>
              <Timer
                header="Time until this video is available!"
                startTime={this.props.videoGist.scheduleStartDate}
                hide={() => this.props.cb()}
              />
              {isVideoEntitled && !this.isFree && (
                  <div className="purchased-copy">
                    <p>{getLocalizedVal(this.props, 'metadataMap', 'videoAlreadyPurchasedLabel') || "You have purchased this video. Sit back, and enjoy when it starts"}</p>
                  </div>
                )}
          </div>
        )
    }

    if(this.state.user && this.state.user.istveLoggedIn)
      return <div className="waysSpinner" style={ background }> <div className="contentNotAvailable">{getLocalizedVal(window.settings,'genericMessages', 'ContentNotAvailableforTVProvider')}</div></div>

    return(
      <div className="waysToWatchPrompt" style={ background }>
        <div className="overlay">
          <div className="optionTypes">
            {!this.state.user && !this.state.isLoginRequired && this.state.isEmailRequired && this.emailForm()}
          </div>
        </div>
      </div>
    )
  }
}

connect(WaysToWatch, (state) => ({user:state.user}), userStore)
export default WaysToWatch;